import { createAction } from "redux-actions";
import { createSelector } from "reselect";
import { path, prop, identity } from "ramda";
import screenfull from "screenfull";

// Actions
export const OPEN_FULL_SCREEN = "APP@SCREEN::FULL_OPEN";
export const CLOSE_FULL_SCREEN = "APP@SCREEN::FULL_CLOSE";
export const SET_SCALE_PANZOOM_SCREEN = "APP@SCREEN::SET_SCALE_PANZOOM";

// Action Creators
export const openFullScreen = createAction(OPEN_FULL_SCREEN);
export const closeFullScreen = createAction(CLOSE_FULL_SCREEN);
export const setPanzoomScale = createAction(SET_SCALE_PANZOOM_SCREEN);

export const setFullScreen = isFullScreen => dispatch => {
  dispatch(isFullScreen ? closeFullScreen() : openFullScreen());
};

export const toggleFullScreen = () => () => {
  if (screenfull.isEnabled) {
    screenfull.toggle();
  }
};

// Selectors
const getScreen = path(["application", "screen"]);
export const selectScreen = createSelector(getScreen, identity);
export const selectIsFullScreen = createSelector(
  getScreen,
  prop("isFullScreen")
);
export const selectPanzoomScale = createSelector(
  getScreen,
  prop("panzoomScale")
);

// Initial State
const initialState = () => ({
  panzoomScale: 1,
  isFullScreen: false
});

// Reducer
export default function reducer(state = initialState(), action = {}) {
  switch (action.type) {
    case SET_SCALE_PANZOOM_SCREEN:
      return { ...state, panzoomScale: action.payload };
    case OPEN_FULL_SCREEN:
      return { ...state, isFullScreen: true };
    case CLOSE_FULL_SCREEN:
      return { ...state, isFullScreen: false };
    default:
      return state;
  }
}
